export function setJson(data) {
  return JSON.stringify(data);
}

export function getJson(data) {
  try {
    return data ? JSON.parse(data) : "";
  } catch (error) {
    return "";
  }
}
